import { requestCommon } from '../libs/axios'
import router from "@/router/index.js";

export const buriedPoint = (params) => requestCommon.post('/burypoint/point', params) // 页面埋点
export const buriedChannelPoint = (params) => {
    const extra = {
        ...params.extra || {},
        h5PageName: router.currentRoute.path
    }
    return requestCommon.post('/burypoint/channel/point', {
        ...params,
        extra
    })
} // 活动页面埋点
